// extracted by mini-css-extract-plugin
export default {"title":"_3f9d2b9f32","inner_title":"_04ffa83bc2","charge_btn":"bfd0bfddd7"};